import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { IconComponent } from "../icon/icon.component";
import { Icon, Icons } from '../../../model/icon';
import { ImageSlide } from '../../../model/imageSlide';
import {NgClass, NgIf} from '@angular/common';

@Component({
  selector: 'app-images-scroll',
  imports: [
    IconComponent,
    NgClass,
    NgIf
  ],
  templateUrl: './images-scroll.component.html',
  styleUrls: ['./images-scroll.component.scss']
})
export class ImagesScrollComponent implements OnInit, OnDestroy {
  @Input() imagesCards: ImageSlide[] = [];

  idx: number = 0;
  iconLeft: Icon = Icons.arrow;
  iconRight: Icon = Icons.arrowRight;
  animationClass: string = '';
  intervalId: any; // Для хранения идентификатора интервала

  ngOnInit() {
    if (this.imagesCards.length > 0) {
      this.startAutoScroll();
    }
  }

  ngOnDestroy() {
    // Очищаем интервал при уничтожении компонента
    clearInterval(this.intervalId);
  }

  startAutoScroll() {
    this.intervalId = setInterval(() => {
      // this.turnRight();
    }, 5000);
  }

  setBackgroundPosition(img?: string) {
    if (img) {
      const back = `background-image: url("${img}");`;
      return back;
    } return '';
  }

  mouseOver(left: boolean) {
    if (left) {
      this.iconLeft = Icons.arrowGold;
    } else {
      this.iconRight = Icons.arrowGoldRight;
    }
  }

  mouseLeave() {
    this.iconLeft = Icons.arrow;
    this.iconRight = Icons.arrowRight;
  }

  turnLeft() {
    this.animationClass = 'slide-out-right';
    clearInterval(this.intervalId);
    this.startAutoScroll();
    setTimeout(() => {
      this.idx = (this.idx - 1 + this.imagesCards.length) % this.imagesCards.length;
      this.animationClass = 'slide-in-left';
    }, 300);
  }

  turnRight() {
    this.animationClass = 'slide-out-left';
    clearInterval(this.intervalId);
    this.startAutoScroll();
    setTimeout(() => {
      this.idx = (this.idx + 1) % this.imagesCards.length;
      this.animationClass = 'slide-in-right';
    }, 300);
  }

  setPosition() {
    return this.imagesCards[this.idx].pos ?  `object-position: ${this.imagesCards[this.idx].pos};` : ``;
  }
}
